<template>
  <div class="position-relative store-menu-wrapper"  ref="store_menu_wrapper">
    <ul class="store-menu nav" ref="store_menu">
      <li
        v-for="category in categories"
        :key="category.ID"
        class="nav-item"
        :style="desktopStyles.MenuHighlight"
        @mouseover="updateHover(category,true)"
        @mouseleave="updateHover(category,false)"
        @click="updateSelected(category)"
      >
        <a :style="itemHover(category)" :href="'#section-' + category.ID" class="fw-600 store-link" :class="sushiHub && ' montserrat-700'">
          {{
          category.Name
          }}
        </a>
      </li>
    </ul>
    <ul class="nav collect">
      <li class="dropdown" ref="dropdown">
        <a
          role="button"
          aria-expanded="false"
          aria-haspopup="true"
          href="#"
          data-toggle="dropdown"
          class="nav-item dropdown-toggle fw-600"
          :class="sushiHub && 'text-white'"
          :style="dropdownStyle()"
          @mouseover="updateDropdownHover(true)"
          @mouseleave="updateDropdownHover(false)"
          id="dropdownMenu2"
        >{{ $t('message.more') }}</a>
        <ul
          id="submenu"
          ref="submenu"
          role="menu"
          class="dropdown-menu"
          aria-labelledby="dropdownMenu2"
          :style="desktopStyles.nav"
        >
          <li
            v-for="category in categories"
            :style="desktopStyles.MenuHighlight"
            @mouseover="updateHover(category,true)"
            @mouseleave="updateHover(category,false)"
            :key="category.ID"
            class="dropdown-item menulink"
          >
            <a
              :href="'#section-' + category.ID"
              class="fw-600 store-link"
            >
              {{
              category.Name
              }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>


<script>
import $ from "jquery";
import { $$ } from "./../../sharedscripts/OO_jquery";
import { mapGetters } from "vuex";
export default {
  name: "ResturantMenu",
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    sushiHub : {
      type : Boolean
    }
  },
  data() {
    return {
      activeMenu: 0,
      once: true,
      varWidth: 0,
      WidthItemMenu: [],
      menuItemCount: 0,
      categoryChanged: false,
      hoverState: [],
      selected: null,
      isDropdodwnHover: false,
      windowwidth:0
    };
  },
  computed: {
    ...mapGetters(["desktopStyles"])
  },
  beforeDestroy() {
    window.onscroll = null;
    window.removeEventListener("resize", this.arrangeMenu, false);
  },
  watch: {
    categories() {
      this.categoryChanged = true;
    }
  },
  mounted() {
    // this.loadFirst(6);
    $$(".dropdown-toggle").dropdown();
    $$(this.$refs.dropdown).hide();

    var __$$ = $$;
    var scrollHandler = function() {
      if (localStorage.getItem("animating") == "false") {
        // If there's a timer, cancel it
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }

        // Setup the new requestAnimationFrame()
        timeout = window.requestAnimationFrame(function() {
          var links = $$(".store-link");
          var sections = links.toArray().map(i => {
            return i.hash;
          });
          // Run our scroll functions
          var scrollTop = $$(window).scrollTop();

          for (let index = sections.length - 1; index >= 0; index--) {
            const element = sections[index];
            if ($$(element).offset()) {
              if (scrollTop >= $$(element).offset().top - 300) {
                previousIndex = currentIndex;
                currentIndex = index;
                if (previousIndex != currentIndex) {
                  var id = $$(element).attr("id");
                  links.parent().removeClass("active");
                  var current = links.filter("[href*='#" + id + "']");
                  current.parent().addClass("active");
                  current.parent().trigger("click");
                }
                break;
              }
            }
          }
        });
      }
    };

    //icon-menu height
    var menuHeight = 70;
    var previousIndex = -2;
    var currentIndex = -1;
    localStorage.setItem("animating", false);
    var that = this;
    $$(".dropdown").hover(function() {
      $$(".dropdown-toggle").dropdown("hide");
    });
    $$(this.$refs.store_menu_wrapper).off("click", ".store-link");
    $$(this.$refs.store_menu_wrapper).on("click", ".store-link", function(
      event
    ) {
      $$(that.$refs.store_menu)
        .find("li")
        .removeClass("active");

      $$(that.$refs.submenu)
        .find("li")
        .removeClass("active");

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();
        $$(this)
          .parent()
          .addClass("active");
        // Store hash
        var hash = this.hash;
        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        localStorage.setItem("animating", true);
        $("html, body").animate(
          {
            scrollTop: __$$(hash).offset().top - menuHeight
          },
          500,
          function() {
            // Add hash (#) to URL when done scrolling (default click behavior)
            // window.location.hash = hash;
            localStorage.setItem("animating", false);
          }
        );
      } // End if
    });

    // Setup a timer
    var timeout;
    // Listen for resize events
    window.removeEventListener("scroll", scrollHandler, false);
    window.addEventListener("scroll", scrollHandler, false);

    this.windowwidth = window.innerWidth;


    var links = $$(".store-link");
    var section = links.toArray().map(i => {
      return i.hash;
    })[0];
    if ($$(section).offset()) {
      previousIndex = currentIndex;
      currentIndex = 0;
      if (previousIndex != currentIndex) {
        var id = $$(section).attr("id");
        links.parent().removeClass("active");
        var current = links.filter("[href*='#" + id + "']");
        current.parent().addClass("active");
        current.parent().trigger("click");
      }
    }
    this.responsiveMenu(true);
  },
  updated() {
    var __$$ = $$;
    var scrollHandler = function() {
      if (localStorage.getItem("animating") == "false") {
        // If there's a timer, cancel it
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }

        // Setup the new requestAnimationFrame()
        timeout = window.requestAnimationFrame(function() {
          var links = $$(".store-link");
          var sections = links.toArray().map(i => {
            return i.hash;
          });
          // Run our scroll functions
          var scrollTop = $$(window).scrollTop();

          for (let index = sections.length - 1; index >= 0; index--) {
            const element = sections[index];
            if ($$(element).offset()) {
              if (scrollTop >= $$(element).offset().top - 300) {
                previousIndex = currentIndex;
                currentIndex = index;
                if (previousIndex != currentIndex) {
                  var id = $$(element).attr("id");
                  links.parent().removeClass("active");
                  var current = links.filter("[href*='#" + id + "']");
                  current.parent().addClass("active");
                  current.parent().trigger("click");
                }
                break;
              }
            }
          }
        });
      }
    };
    if (this.once) {
      this.once = false;
      //icon-menu height
      var menuHeight = 70;
      var previousIndex = -2;
      var currentIndex = -1;
      localStorage.setItem("animating", false);
      var that = this;
      $$(".dropdown").hover(function() {
        $$(".dropdown-toggle").dropdown("hide");
      });
      $$(this.$refs.store_menu_wrapper).off("click", ".store-link");
      $$(this.$refs.store_menu_wrapper).on("click", ".store-link", function(
        event
      ) {
        $$(that.$refs.store_menu)
          .find("li")
          .removeClass("active");

        $$(that.$refs.submenu)
          .find("li")
          .removeClass("active");

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
          // Prevent default anchor click behavior
          event.preventDefault();
          $$(this)
            .parent()
            .addClass("active");
          // Store hash
          var hash = this.hash;
          // Using jQuery's animate() method to add smooth page scroll
          // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
          localStorage.setItem("animating", true);
          $("html, body").animate(
            {
              scrollTop: __$$(hash).offset().top - menuHeight
            },
            500,
            function() {
              // Add hash (#) to URL when done scrolling (default click behavior)
              // window.location.hash = hash;
              localStorage.setItem("animating", false);
            }
          );
        } // End if
      });

      // Setup a timer
      var timeout;
      // Listen for resize events
      window.removeEventListener("scroll", scrollHandler, false);
      window.addEventListener("scroll", scrollHandler, false);

     this.responsiveMenu(true);
    }
    if (this.categoryChanged) {
      this.responsiveMenu(false);
      this.categoryChanged = false;
    }
  },
  methods: {
    arrangeMenu(first = false) {
      if(this.windowwidth != window.innerWidth || first == true)
      {
        this.windowwidth = window.innerWidth;
        var $menu = $$(this.$refs.store_menu),
          $collectedSet,
          $collectedSetDropDown,
          elemWidth,
          fitCount = 0;

        elemWidth = $menu.width();
        let widthFilter = this.WidthItemMenu.filter(function(number) {
          return number < elemWidth;
        });
        fitCount = widthFilter.length - 1;
        if (fitCount < 0) fitCount = 0;

        $menu.children().css({ display: "block", width: "auto" });
        $$(this.$refs.submenu)
          .children()
          .css({ display: "none", width: "0" });

        $collectedSet = $menu.children(":gt(" + fitCount + ")");
        $collectedSet.css({ display: "none", width: "0" });
        $collectedSetDropDown = $$(this.$refs.submenu).children(
          ":gt(" + fitCount + ")"
        );
        $collectedSetDropDown.css({ display: "block", width: "auto" });
        if ($collectedSet.length == 0) $$(this.$refs.dropdown).hide();
        else {
          $$(this.$refs.dropdown).show();
        }
      }
    },
    loadFirst(count) {
      var $menu = $$(this.$refs.store_menu); // $(".store-menu");
      $menu.children().css({ display: "none", width: "auto" });
      $menu.children().each(function(index) {
        if (index < count) {
          $$(this).css({ display: "block", width: "auto" });
        }
      });
    },
    responsiveMenu(firstTime) {

      var $menu = $$(this.$refs.store_menu); // $(".store-menu");
      var that = this;
      that.WidthItemMenu = [];
      that.varWidth = 0;
      this.menuItemCount = $menu.children().length;
      $menu.children().css({ display: "block", width: "auto" });
      //for (var index = 0; index < $menu.children().length; index++) {
      this.$nextTick(() => {
        $menu.children().each(function() {
          that.varWidth += $$(this).outerWidth();
          that.WidthItemMenu.push(that.varWidth);
        });
        this.arrangeMenu(true);
      });
      if (firstTime){
        window.addEventListener('resize', this.arrangeMenu,false);
      }
    },
    dropdownStyle() {
      var style = [];
      if (this.isDropdodwnHover)
        style.push(this.desktopStyles.MenuHighlightedText);
      else style.push(this.desktopStyles.navText);

      return style;
    },
    itemHover(category) {
      var state = this.hoverState.find(p => p.categoryId == category.ID);
      var style = [];
      if (state && state.hover) {
        if(this.sushiHub){
          style.push({color : "#ffffff"});
        }else {
          style.push(this.desktopStyles.MenuHighlightedText);
        }

      }
      if (this.selected && this.selected.ID == category.ID) {
        if(this.sushiHub){

          style.push({color : "#ffffff"});
        }else{
          style.push(this.desktopStyles.MenuHighlightedText);
        }


      }
      if (style.length == 0) {
        if (this.sushiHub) {
          style.push({color : "#b7bbbb"});}
        else {
          style.push(this.desktopStyles.navText);
        }
      }
      return style;
    },
    updateDropdownHover(hover) {
      this.isDropdodwnHover = hover;
    },
    updateHover(category, hover) {
      var state = this.hoverState.find(p => p.categoryId == category.ID);
      if (state) {
        state.hover = hover;
      } else {
        this.hoverState.push({ categoryId: category.ID, hover: hover });
      }
    },
    updateSelected(category) {
      this.selected = category;
    }
  }
};
</script>
